var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "operator-selector" }, [
    _c(
      "div",
      { staticClass: "radios" },
      [
        _c("radio-selectors", {
          attrs: { options: _vm.modes, value: [_vm.mode] },
          on: { input: _vm.changeMode },
        }),
        _vm._v(" "),
        _c("span", [_vm._v("the following operators")]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "list" },
      [
        _vm._l(
          _vm.displayListForSelectedOperators,
          function (selection, index) {
            return [
              selection.length
                ? _c(
                    "input-button",
                    {
                      key: index,
                      staticClass: "operator",
                      attrs: { icon: "remove" },
                      on: {
                        "click-inner": function ($event) {
                          return _vm.removeOperator(index)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.operatorLabel[selection]) +
                          "\n            "
                      ),
                    ]
                  )
                : _c(
                    "select",
                    {
                      key: index,
                      staticClass: "dropdown-select form-control",
                      domProps: { value: selection },
                      on: {
                        input: function ($event) {
                          return _vm.updateOperator(index, $event)
                        },
                      },
                    },
                    _vm._l(_vm.operators, function (operator) {
                      return _c(
                        "option",
                        {
                          key: operator.value,
                          domProps: { value: operator.value },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(operator.label) +
                              "\n                "
                          ),
                        ]
                      )
                    }),
                    0
                  ),
            ]
          }
        ),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }